// Missing conversation identifiers must never count as a match.
export function isViewingMessage(visible, message) {
  if (!visible || !message) return false;
  const matches = (left, right) => left != null && left !== '' && right != null && right !== '' && String(left) === String(right);
  return matches(visible.senderId, message.senderId)
    || matches(visible.recipientId, message.senderId)
    || matches(visible.conversationId, message.conversationId);
}

export function messageNotificationUrl(message, role) {
  if (String(role).toLowerCase() === 'client') return '/client/messages';
  const tab = message.conversationId ? 'organization' : 'clients';
  return `/midwife/messages?tab=${tab}&conversation=${encodeURIComponent(message.conversationId || message.senderId || '')}`;
}
